import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	overflow-wrap: break-word;
	width: calc(100% + ${helpers.spacing.xxLarge});
	padding: 0 ${helpers.spacing.large} ${helpers.spacing.xLarge};
	margin: ${helpers.spacing.xLarge} -${helpers.spacing.large} ${helpers.spacing.xLarge};
	border-bottom: 1px solid ${helpers.color.border};
	color: ${helpers.color.text};

	&:last-child {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}
`
